import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Seating of the future",
  "description": "",
  "published": "2007-02-04T00:00:00.000Z",
  "redirect_from": ["/blog/seating-of-the-future/swizec/293"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.videosift.com"
      }}>{`Via: `}<em parentName="a">{`VideoSift`}</em></a></p>
    <p>{`There are no words that could sufficiently describe the extent of my desire to possess this thing of magic.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      